module.exports = __webpack_public_path__ + "img/20220219_072857.35d8c634.jpg";